import { __awaiter } from "tslib";
const namespaced = true;
class State {
    constructor() {
        this.isOpened = false;
        this.activePopup = null;
        this.firstClosing = false;
    }
}
const getters = {
    getPopupIsOpened: state => state.isOpened,
    getActivePopup: state => state.activePopup,
    getFirstClosing: state => state.firstClosing
};
const actions = {
    openPopup({ commit, dispatch }, payload) {
        dispatch('setClosed');
        commit('setOpened', payload);
    },
    setFirstClosing({ commit }, payload) {
        commit('setFirstClosing', payload);
    },
    setClosed({ commit, getters }) {
        return __awaiter(this, void 0, void 0, function* () {
            const activePopup = getters.getActivePopup;
            commit('setClosed');
            if (activePopup && activePopup.onBeforeClose !== undefined) {
                yield activePopup.onBeforeClose();
            }
        });
    }
};
const mutations = {
    setOpened(state, payload) {
        state.isOpened = true;
        state.activePopup = payload;
    },
    setClosed(state) {
        state.isOpened = false;
        state.activePopup = null;
    },
    setSlotData(state, payload) {
        if (state.isOpened === true && state.activePopup !== null && state.activePopup.slot !== undefined) {
            state.activePopup = Object.assign(Object.assign({}, state.activePopup), { slot: Object.assign(Object.assign({}, state.activePopup.slot), { data: Object.assign(Object.assign({}, state.activePopup.slot.data), payload) }) });
        }
    },
    setFirstClosing(state, payload) {
        state.firstClosing = payload;
    }
};
export default {
    namespaced,
    state: new State(),
    getters,
    actions,
    mutations
};
